import { Box, Text, Anchor, Group, TextInput, ActionIcon } from "@mantine/core";
import { useState } from "react";
import { IconCheck, IconEdit, IconTrash, IconX } from "@tabler/icons-react";
import { useEditSessionLink } from "../../api/session";

function SessionLinkCard({ link, sessionId, onDeleteLink }) {
  const [isEditing, setIsEditing] = useState(false);
  const [linkTitle, setLinkTitle] = useState(link.title);

  const { mutate } = useEditSessionLink({
    sessionId,
    linkId: link.id,
  });

  const handleSave = () => {
    if (linkTitle.trim() && linkTitle !== link.title) {
      mutate({ title: linkTitle });
    }
    setIsEditing(false);
  };

  return (
    <Group
      key={link.id}
      justify="space-between"
      p="xs"
      style={{
        border: "1px solid var(--mantine-color-gray-3)",
        borderRadius: "4px",
      }}
    >
      <Box style={{ maxWidth: "70%", minWidth: 0, flex: 1 }}>
        <Group gap="xs" align="center" wrap="nowrap">
          {isEditing ? (
            <>
              <TextInput
                value={linkTitle}
                onChange={(e) => setLinkTitle(e.currentTarget.value)}
                size="sm"
                style={{ flex: 1, minWidth: 0 }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSave();
                  if (e.key === "Escape") {
                    setLinkTitle(link.title);
                    setIsEditing(false);
                  }
                }}
                autoFocus
              />
            </>
          ) : (
            <>
              <Text
                size="sm"
                fw={500}
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "100%",
                }}
                title={link.title}
              >
                {link.title}
              </Text>
            </>
          )}
        </Group>
        {link.url ? (
          <Anchor
            href={link.url}
            target="_blank"
            size="sm"
            c="blue"
            style={{
              display: "block",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
            }}
            title={link.url}
          >
            {link.url}
          </Anchor>
        ) : link.fileKey ? (
          <Anchor
            href={link.fileKey}
            target="_blank"
            size="sm"
            style={{
              display: "block",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
            }}
            title={link.fileKey}
          >
            Hosted by RoundCube
          </Anchor>
        ) : null}
      </Box>
      <Group gap="xs">
        {!isEditing && (
          <ActionIcon
            color="gray"
            variant="light"
            onClick={() => setIsEditing(true)}
          >
            <IconEdit size={16} />
          </ActionIcon>
        )}
        {isEditing && (
          <>
            <ActionIcon color="green" variant="light" onClick={handleSave}>
              <IconCheck size={16} />
            </ActionIcon>
            <ActionIcon
              color="gray"
              variant="light"
              onClick={() => {
                setLinkTitle(link.title);
                setIsEditing(false);
              }}
            >
              <IconX size={16} />
            </ActionIcon>
          </>
        )}
        <ActionIcon
          color="red"
          variant="light"
          onClick={() => onDeleteLink({ id: link.id })}
        >
          <IconTrash size={16} />
        </ActionIcon>
      </Group>
    </Group>
  );
}

export default SessionLinkCard;
